// EditRicaviDialog.tsx
import React, { useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  CircularProgress,
  Typography,
} from '@mui/material';
import {useForm, Controller, SubmitHandler} from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {MonitorProgettiRiepilogo, RicProg} from './types'; // or wherever it is
import {useGetRicProgByProg, useUpdateRicProg, useCreateRicProg, useUpsertRicProg} from './Services';
import {validationSchemaRicavi} from "./Services";


interface EditRicaviProps {
  open: boolean;
  onClose: () => void;
  codprog: string;
  ditta: number;
}


const EditRicavi: React.FC<EditRicaviProps> = ({ open, onClose, codprog, ditta }) => {

const {
  control,
  handleSubmit,
  formState: { errors },
  reset,
} = useForm<RicProg>({
  resolver: yupResolver(validationSchemaRicavi),
});




const { data: RicProgData, isError, isFetching } = useGetRicProgByProg(codprog, ditta);



const { mutate: upsertRicProg, isPending, error } = useUpsertRicProg();


const onSubmit: SubmitHandler<RicProg> = (data) => {
  const finalData = { ...data, codprog, ditta };
  upsertRicProg(finalData, {
    onSuccess: onClose,
    onError: (err) => console.error('Upsert error', err),
  });
};

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h6">Modifica Ricavi - {codprog}</Typography>
      </DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Controller
                name="ricavi"
                control={control}
                render={({field, fieldState}) => (
                    <TextField
                        {...field}
                        label="Ricavi"
                        fullWidth
                        error={!!fieldState.error}
                        helperText={fieldState.error?.message}
                    />
                )}
            />

            <Stack direction="row" justifyContent="flex-end" spacing={1}>
              <Button onClick={onClose} color="error" variant="outlined">Annulla</Button>
              <Button
                  type="submit"
                  variant="contained"
                  disabled={isPending}
                  startIcon={isPending && <CircularProgress size={18} color="inherit"/>}
              >
                Salva
              </Button>
            </Stack>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditRicavi;
